var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

/**
 * @copyright
 * Copyright(c) 2019 SICK AG
 */

/* eslint-disable jsdoc/require-param */
import { Component, Prop, CustomElement, Event, nothing, html } from '@sick-davinci/ce-decorators';
import { style } from './ElementContainer.style';
import { IconRef, Icon } from '@sick-davinci/basic-elements';
import { icon_settings } from '@sick-davinci/material-icons/action/settings.icon.js';
import { icon_help_outline } from '@sick-davinci/material-icons/action/help_outline.icon.js';
import { icon_chevron_left } from '@sick-davinci/material-icons/navigation/chevron_left.icon.js';
import { icon_chevron_right } from '@sick-davinci/material-icons/navigation/chevron_right.icon.js'; // import theme, so color-variables can be resolved

import '@sick-davinci/theme-base/theme/light_theme.js';
import '@sick-davinci/theme-base/theme/light_ddg_theme.js';
/**
 * A container for dashboard elements (with possibilities to change settings, navigate, ...)
 *
 * @example
 * ```
 *   <davinci-element-container style="width: 300px; height: 300px; text-align: center">
 *     <davinci-numeric-chart value='42'></davinci-numeric-chart>
 *   </davinci-element-container>
 * ```
 * @slot { * } default - default slot, can consume any element
 */

export let ElementContainer = (_dec = Component({
  tag: 'davinci-element-container',
  style,
  dependencies: [Icon, IconRef]
}), _dec2 = Prop({
  reflectAsAttribute: false
}), _dec3 = Reflect.metadata("design:type", String), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", Boolean), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", Boolean), _dec8 = Prop(), _dec9 = Reflect.metadata("design:type", Boolean), _dec10 = Prop(), _dec11 = Reflect.metadata("design:type", Boolean), _dec12 = Prop(), _dec13 = Reflect.metadata("design:type", String), _dec14 = Prop(), _dec15 = Reflect.metadata("design:type", Boolean), _dec16 = Prop(), _dec17 = Reflect.metadata("design:type", Boolean), _dec18 = Event(), _dec19 = Reflect.metadata("design:type", Object), _dec20 = Event(), _dec21 = Reflect.metadata("design:type", Object), _dec22 = Event(), _dec23 = Reflect.metadata("design:type", Object), _dec24 = Event(), _dec25 = Reflect.metadata("design:type", Object), _dec26 = Event(), _dec27 = Reflect.metadata("design:type", Object), _dec(_class = (_class2 = class ElementContainer extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "help", _descriptor, this);

    _initializerDefineProperty(this, "forward", _descriptor2, this);

    _initializerDefineProperty(this, "back", _descriptor3, this);

    _initializerDefineProperty(this, "settings", _descriptor4, this);

    _initializerDefineProperty(this, "heading", _descriptor5, this);

    _initializerDefineProperty(this, "centered", _descriptor6, this);

    _initializerDefineProperty(this, "footer", _descriptor7, this);

    _initializerDefineProperty(this, "stateClicked", _descriptor8, this);

    _initializerDefineProperty(this, "helpClicked", _descriptor9, this);

    _initializerDefineProperty(this, "settingsClicked", _descriptor10, this);

    _initializerDefineProperty(this, "backClicked", _descriptor11, this);

    _initializerDefineProperty(this, "forwardClicked", _descriptor12, this);
  }

  /**
   * left-aligned svg-icon in the header (see <davinci-icon-ref> for more details),
   * which shows the state of the underlying element.
   * The according event is fired when clicked.
   *
   * @default ''
   */
  get stateIcon() {
    return '';
  }

  set stateIcon(value) {
    this._stateIcon = value;
  }
  /**
   * Enables the help icon in the header of this container.
   * The according event is fired when clicked.
   */


  /**
   * See base class
   */
  render() {
    return html`<div id='header'>
      <div id='state'>${!!this._stateIcon ? this._renderIcon(this._stateIcon, 'icon', this._onStateClick) : nothing}</div>
      <div id='help'>${this.help ? this._renderIcon(icon_help_outline, 'icon', this._onHelpClick) : nothing}</div>
      <div id='title'>${this.heading}</div>
      <div id='setting'>${this.settings ? this._renderIcon(icon_settings, 'icon', this._onSettingsClick) : nothing}</div>
    </div>
    <div id='center'>
      <slot></slot>
    </div>
    <div id='footer'>
      <div id='left'>${this.back ? this._renderIcon(icon_chevron_left, 'icon', this._onBackClick) : nothing}</div>
      <div id='gap'></div>
      <div id='right'>${this.forward ? this._renderIcon(icon_chevron_right, 'icon', this._onForwardClick) : nothing}</div>
    </div>
    </div>`;
  }

  _renderIcon(icon, clazz, onClick) {
    if (icon) {
      return html`
        <davinci-icon-ref
          .src="${icon}"
          class="${clazz}"
          @click="${onClick}"
        ></davinci-icon-ref>
      `;
    }

    return html``;
  }

  _onHelpClick(_event) {
    this.helpClicked.emit();
  }

  _onStateClick(_event) {
    this.stateClicked.emit();
  }

  _onSettingsClick(_event) {
    this.settingsClicked.emit();
  }

  _onBackClick(_event) {
    this.backClicked.emit();
  }

  _onForwardClick(_event) {
    this.forwardClicked.emit();
  }

}, (_applyDecoratedDescriptor(_class2.prototype, "stateIcon", [_dec2, _dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "stateIcon"), _class2.prototype), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "help", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "forward", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "back", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "settings", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "heading", [_dec12, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'Caption';
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "centered", [_dec14, _dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "footer", [_dec16, _dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "stateClicked", [_dec18, _dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "helpClicked", [_dec20, _dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "settingsClicked", [_dec22, _dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "backClicked", [_dec24, _dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "forwardClicked", [_dec26, _dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
